import {
    isImageMimeType,
    isVideoMimeType,
    resolveMimeType,
} from "@wags/utils/media.ts";

type MediaLike = {
    id?: string | null;
    url?: string | null;
    mimeType?: string | null;
};

function getResolvedMimeType(media: MediaLike) {
    return resolveMimeType(media.mimeType, media.url);
}

export function isVideoMedia(media: MediaLike) {
    return isVideoMimeType(getResolvedMimeType(media));
}

function isImageMedia(media: MediaLike) {
    return isImageMimeType(getResolvedMimeType(media));
}

export function pickPreferredImageMedia<T extends MediaLike>(
    mediaItems: T[],
    preferredId?: string | null,
) {
    if (preferredId) {
        const preferredMedia = mediaItems.find(
            (media) => media.id === preferredId && isImageMedia(media),
        );
        if (preferredMedia) {
            return preferredMedia;
        }
    }

    return mediaItems.find((media) => isImageMedia(media));
}

export function sortMediaItemsForDisplay<T extends MediaLike>(
    mediaItems: T[],
    preferredId?: string | null,
) {
    return mediaItems
        .map((media, index) => ({ media, index }))
        .sort((left, right) => {
            const leftIsPreferred =
                preferredId != null && left.media.id === preferredId;
            const rightIsPreferred =
                preferredId != null && right.media.id === preferredId;
            const leftIsImage = isImageMedia(left.media);
            const rightIsImage = isImageMedia(right.media);

            const leftRank =
                leftIsPreferred && leftIsImage
                    ? 0
                    : leftIsImage
                      ? 1
                      : leftIsPreferred
                        ? 2
                        : 3;
            const rightRank =
                rightIsPreferred && rightIsImage
                    ? 0
                    : rightIsImage
                      ? 1
                      : rightIsPreferred
                        ? 2
                        : 3;

            if (leftRank !== rightRank) {
                return leftRank - rightRank;
            }

            return left.index - right.index;
        })
        .map(({ media }) => media);
}
